import { flattenNav, portalNav } from './navConfig'
import { AREAS_PATH } from '../areas/areas'
import { areasNavegaveis, primeiraTelaDaArea, type UsuarioComAreas } from '../areas/acesso'

/** Rota de saída quando o acesso não alcança nenhuma tela. */
export const SEM_ACESSO_PATH = '/sem-acesso'

/** O que `homePathFor` precisa saber do usuário. Um objeto, e não um booleano,
 *  porque a escolha depende das áreas e das permissões, não só do lado. */
export type UsuarioParaHome = UsuarioComAreas

/** Caminho inicial do usuário.
 *
 *  Equipe, desde as áreas (24/10/2026):
 *  - nenhuma área ao alcance: `/sem-acesso`, que explica a situação;
 *  - uma área: a primeira tela que ele alcança nela, sem passar pela escolha;
 *  - duas ou mais: a tela de escolha de área.
 *
 *  "Ao alcance" é a área liberada pelo servidor que tem ao menos uma tela do menu
 *  que a pessoa pode abrir. Por isso o destino nunca é uma tela recusada logo
 *  depois do login, e nunca é a raiz de uma área vazia, o que fecharia um laço
 *  com o portão.
 *
 *  Portal do cliente: a primeira tela do menu do portal que ele alcança, como
 *  antes. `SEM_ACESSO_PATH` não é gateada por permissão nenhuma, e é isso que
 *  impede o laço com o PermissionGate. */
export function homePathFor(usuario: UsuarioParaHome | boolean | null | undefined): string {
  // Compatibilidade com as chamadas que passavam só o lado. Sem as áreas não há o
  // que avaliar, e a tela de áreas resolve o destino com o usuário de verdade.
  if (typeof usuario === 'boolean' || usuario == null) {
    return usuario ? AREAS_PATH : '/portal'
  }
  if (usuario.is_staff) {
    const areas = areasNavegaveis(usuario)
    if (areas.length === 0) return SEM_ACESSO_PATH
    if (areas.length === 1) return primeiraTelaDaArea(areas[0], usuario) ?? SEM_ACESSO_PATH
    return AREAS_PATH
  }

  const concedidas = new Set(usuario.permissions ?? [])
  for (const item of flattenNav(portalNav)) {
    if (item.adminOnly && usuario.role !== 'customer_admin') continue
    if (!item.permission || concedidas.has(item.permission)) return item.path
  }
  return SEM_ACESSO_PATH
}
